// Portrait generator — pure functions, no mutations
// Takes config, returns ImageData or draws to a provided canvas context

const SIZE = 64;

/**
 * Creates a 64x64 smiley face as pixel data
 * @returns {ImageData} 64x64 image data
 */
export function generateSmileyPortrait() {
  const canvas = document.createElement('canvas');
  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext('2d');

  // Background — white
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, SIZE, SIZE);

  // Head circle — black outline
  ctx.strokeStyle = '#000000';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(32, 32, 26, 0, Math.PI * 2);
  ctx.stroke();

  // Left eye
  ctx.fillStyle = '#000000';
  ctx.fillRect(22, 24, 4, 4);

  // Right eye
  ctx.fillRect(38, 24, 4, 4);

  // Mouth — arc
  ctx.beginPath();
  ctx.arc(32, 36, 10, 0.1 * Math.PI, 0.9 * Math.PI);
  ctx.stroke();

  return ctx.getImageData(0, 0, SIZE, SIZE);
}

/**
 * Renders ImageData to a data URL string
 * @param {ImageData} imageData
 * @returns {string} data URL (image/png)
 */
export function imageDataToUrl(imageData) {
  const canvas = document.createElement('canvas');
  canvas.width = imageData.width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext('2d');
  ctx.putImageData(imageData, 0, 0);
  return canvas.toDataURL('image/png');
}
